function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { useCustomField } from '../../../common/hooks/useCustomField';
import Signed from './Signed';

const PriceFormatField = ({
  onChange,
  name,
  value,
  isInvalid,
  isValid,
  autoDefaultValue,
  staticValueChange,
  staticValueChangeWithDirty,
  triggerChangeWithoutDirtying,
  className,
  decimalPlaces,
  ...props
}) => {
  const once = useRef(false);
  const [customField, setCustomField] = useCustomField({
    name: name || "",
    onChange,
    value,
    triggerChangeWithoutDirtying
  });
  useEffect(() => {
    if (!once.current && value && !customField.dirty || staticValueChange || staticValueChangeWithDirty || triggerChangeWithoutDirtying) {
      // to prevent dirtying on setting default value
      const triggerStaticValueChangeWithDirty = once.current && staticValueChangeWithDirty;
      setCustomField(prev => ({ ...prev,
        dirty: triggerStaticValueChangeWithDirty || false,
        value: `${value}` ? !isNaN(parseFloat(`${value}`)) ? parseFloat(`${value}`).toFixed(decimalPlaces) : value : ''
      }));
      once.current = true;
    }
  }, [value]);

  const handleBlur = event => {
    const valueRaw = event.target.value;
    const match = event.target.value.match(/\-?[\d\.]+/);
    const value = parseFloat(match ? match[0] : "0");
    setCustomField(prev => ({ ...prev,
      dirty: true,
      value: [autoDefaultValue, ""].includes(valueRaw) ? autoDefaultValue || "" : isNaN(value) ? valueRaw : value.toFixed(decimalPlaces)
    }));
  };

  const handleChange = event => {
    const value = event.target.value;
    setCustomField(prev => ({ ...prev,
      dirty: true,
      value
    }));
  };

  const handleFocus = event => {
    const value = event.target.value;
    event.target.setSelectionRange(0, value.length);
  };

  return /*#__PURE__*/React.createElement("input", _extends({
    className: classNames("form-control", {
      "is-invalid": isInvalid,
      "is-valid": isValid
    }, className),
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus,
    value: customField.value
  }, props, {
    type: "text"
  }));
};

PriceFormatField.Signed = Signed;
PriceFormatField.defaultProps = {
  decimalPlaces: 2
};
export default PriceFormatField;